<template>
    <div class="footer-bottom bg-white">
      <CRow class="justify-content-center mb-2">
        <CCol style="display: flex; align-items: center; justify-content: center">
          <CCol sm="12" lg="12">
            <CCol
              sm="12"
              lg="12"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
                left: 0;
                right: 0;
                position: fixed;
                bottom: 0px;
                padding:10px;
                background-color: #fff;
              "
            >
              <CCol sm="3" lg="3" class="p-0 m-0" style="flex: 1">
                <CCol @click="GoHome()" class="text-center">
                
                    <img src="../assets/img/Home.png" class="size-24px"/>
                    <br />
                    <label class="text-black"> Home</label>
                 
                </CCol>
              </CCol>
  
              <CCol sm="3" lg="3" class="p-0 m-0" style="flex: 1">
                <CCol @click="GoDiscover()" class="text-center">
                  
                  <img src="../assets/img/discover.png" class="size-24px"/>
                  <br />
                  <label class="text-black"> Discover</label>
                 
                </CCol>
              </CCol>
  
              <CCol sm="3" lg="3" class="p-0 m-0" style="flex: 1">
                <CCol @click="GoNotification()" class="text-center">
                 
                  <img src="../assets/img/Document.png" class="size-24px"/>
                  <br />
                  <label class="text-black"> Booking</label>
               
                </CCol>
              </CCol>
  
              <CCol sm="3" lg="3" class="p-0 m-0" style="flex: 1">
                <CCol @click="GoProfile()" class="text-center">
                 
                  <img src="../assets/img/Profile.png" style="width:18px;"/>
                  <br />
                  <label class="text-black"> Profile</label>
                </CCol>
              </CCol>
  
            
            </CCol>
          </CCol>
        </CCol>
      </CRow>
    </div>
  </template>
  
              
  <script>
  import Vue from "vue";
  
  import MainlayoutBottom from "../containers/TheBottomCustom.vue";
  
  Vue.use(require("vue-moment"));
  import moment from "moment";
  
  export default {
    components: {
      MainlayoutBottom,
    },
    data: function () {
      return {
      
      };
    },
    async mounted() {
      
    },
    methods: {
     
      GoHome() {
        this.$router.push("/HomeUser");
        
      },
      GoDiscover() {
       
          this.$router.push("/HomeDiscover");
          
        
      },
      GoProfile() {
        this.$router.push("/HomeProfile");
      
      },
      GoTutor() {
        this.tutorclick = true;
        this.tutorclickgrey = false;
        this.$router.push("/FindTutor/FindTutorMainpage");
      },
      GoNotification() {
        this.noticlick = true;
        this.noticlickgrey = false;
        this.$router.push("/Notification");
      },
    },
  };
  </script>
  